module.exports = __webpack_public_path__ + "img/case-restaurant.aeff5c4b.png";